import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const META_PIXEL_ID = '3742787826023305'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return // Already initialized

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', META_PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
    trackPageView()
  }, [])

  return {
    trackAddToCart,
    trackPageView,
  }
}
